import { safeLinkedInUrl } from "../event-experience/external-url";

/**
 * The LinkedIn link as the event pages will show it, or an error to put in
 * front of the person.
 *
 * The attendee card and profile sheet render the link only through
 * `safeLinkedInUrl`, which needs https and a linkedin.com host. A profile that
 * stored `linkedin.com/in/ada` saved without complaint and then showed no link
 * anywhere, which is the same symptom as the link never arriving. A missing
 * scheme is added rather than refused, since that is what people paste.
 */
export function normalizeLinkedInUrl(
  value: string,
): { value: string } | { error: string } {
  const trimmed = value.trim();
  if (!trimmed) return { value: "" };
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;
  const safe = safeLinkedInUrl(withScheme);
  return safe
    ? { value: safe }
    : {
        error:
          "Enter a LinkedIn profile link, for example https://www.linkedin.com/in/your-name.",
      };
}
